<div *ngIf="showLevelScore" class="game-complete-overlay">
  <div class="game-complete-content">
    <h2 class="game-complete-title">{{ 'GAME COMPLETE' | translate }}</h2>
    <div class="score-breakdown">
      <!-- Base Score -->
      <div *ngIf="baseScore !== undefined" class="score-item">
        <ion-icon name="diamond-outline"></ion-icon>
        <span>{{ 'Base Score' | translate }}</span>
        <strong>{{ baseScore }}</strong>
      </div>
      <!-- Time Bonus -->
      <div *ngIf="timeBonus !== undefined" class="score-item">
        <ion-icon name="hourglass-outline"></ion-icon>
        <span>{{ 'Time Bonus' | translate }}</span>
        <strong>{{ timeBonus }}</strong>
      </div>
      <!-- Total Score -->
      <div class="score-item total">
        <ion-icon name="trophy-outline"></ion-icon>
        <span>{{ 'Total Score' | translate }}</span>
        <strong>{{ totalScore }}</strong>
      </div>
    </div>
    <!-- Replay Button -->
    <ion-button (click)="replayGame()" expand="block" class="return-home-btn">
      {{ 'Replay the Game' | translate }}
    </ion-button>
    <ion-button (click)="navigateHome()" expand="block" class="return-home-btn">
      {{ 'Home' | translate }}
    </ion-button>
    <ion-button (click)="closeDialog()" expand="block" class="return-home-btn">
      {{ 'Close' | translate }}
    </ion-button>
  </div>
</div>